/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".select-multiple-header{display:block;margin-bottom:-14px}  .synced-row{float:right}  .preview-dialog>.ui-dialog-content{width:inherit;height:calc(100% - 30px)}.button[_ngcontent-%COMP%]{padding-left:4px;padding-right:4px;margin-left:2px;margin-right:2px}"];
export { styles as styles };
